module.exports = __webpack_public_path__ + "1d1ed4b59eef4d158cf8819533583c8b.png";